<script>
import ColorBox from './ColorBox.vue';
import { OPLUS_COLOR_PALETTE, ROLE_VIEW_TYPE, SLOT_TYPES } from '../js/models.js'
import { changeRoleCreateBtn, updateRoleFromRolesApp, getRoleFromRolesApp, setNewGroupRoleBranch } from '../js/roles.js'
import { putRoleRequest } from '../js/role_requests';
import RolesTable from './RolesTable.vue';
import { extractTimeAndMin } from '../common/common';
import { addZeroPlaceholders } from '../js/common';
import { slotTypeString } from '../common/slotTypesToString';

export default {
  props: {
    havePermission: Object,
    isGroupRoleForm: Boolean,
    isGroupOwner: Boolean,
    selectedOem: Number,
  },
  data() {
    return {
      isColorBoxVisible: false,
      isVisible: false,
      isLoading: false,
      formData: {
        id: 0,
        name: "",
        purpose: "",
        from: "",
        to: "",
        rest: "",
        wage: "",
        isNightShift: false,
        nextDayOff: false,
        showCount: true,
        isCountFixed: false,
        showStaffCount: true,
        color: OPLUS_COLOR_PALETTE.DEFAULT,
        type: ROLE_VIEW_TYPE.DAY_VIEW,
        slotType: SLOT_TYPES.HOURLY,
        kotHolidayType: "",
        externalID: "",
        isHiddenInShiftPage: false,
        isDisabledWhenFull: false,
        groupWide: this.isGroupRoleForm, // always set to true if we are on group-role page
        editSharedSettings: (this.isGroupRoleForm && this.isGroupOwner) || false,
      },
      selectedRoleID: 0,
    }
  },
  methods: {
    initFormData() {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.purpose = "";
      this.formData.from = "";
      this.formData.to = "";
      this.formData.rest = "";
      this.formData.wage = "";
      this.formData.isNightShift = false;
      this.formData.nextDayOff = false;
      this.formData.showCount = true;
      this.formData.isCountFixed = false;
      this.formData.showStaffCount = true;
      this.formData.color = OPLUS_COLOR_PALETTE.DEFAULT;
      this.formData.type = ROLE_VIEW_TYPE.DAY_VIEW;
      this.formData.slotType = SLOT_TYPES.HOURLY;
      this.formData.kotHolidayType = "";
      this.formData.externalID = "";
      this.formData.isHiddenInShiftPage = false;
      this.formData.isDisabledWhenFull = false;
      this.formData.groupWide = this.isGroupRoleForm;
      this.selectedRoleID = 0;
    },
    setFormData(role) {
      this.id = role.ID;
      this.formData.name = role.Name;
      this.formData.purpose = role.Purpose;
      this.formData.from = role.From;
      this.formData.to = role.To;
      this.formData.rest = role.Rest;
      this.formData.wage = role.Wage;
      this.formData.isNightShift = role.IsNightShift;
      this.formData.nextDayOff = role.NextDayOff;
      this.formData.showCount = role.ShowCount;
      this.formData.isCountFixed = role.IsCountFixed
      this.formData.showStaffCount = role.ShowStaffCount;
      this.formData.color = role.Color ? role.Color : OPLUS_COLOR_PALETTE.DEFAULT;
      this.formData.type = role.Type;
      this.formData.slotType = role.SlotType;
      this.formData.kotHolidayType = role.KOTHolidayType;
      this.formData.externalID = role.ExternalID
      this.formData.isHiddenInShiftPage = role.IsHiddenInShiftPage;
      this.formData.isDisabledWhenFull = role.IsDisabledWhenFull;
      this.formData.groupWide = role.GroupWide;
      this.selectedRoleID = role.ID
    },
    openRoleForm() {
      this.isVisible = true
    },
    closeRoleForm() {
      this.isVisible = false
    },
    toggleRoleForm(roleID) {
      const isNewRole = !roleID;

      if (isNewRole) {
        this.initFormData();
      } else {
        this.setFormData(getRoleFromRolesApp(roleID));
      }

      if (!this.isVisible) {
        this.isColorBoxVisible = false;
        this.openRoleForm();
      } else if (isNewRole) {
        this.closeRoleForm();
      }
    },
    openColorBox() {
      this.isColorBoxVisible = true;
    },
    // Close color box outside click
    handleRoleContainerClick(event) {
      if (!this.$refs["color-box"].contains(event.target)) {
        this.isColorBoxVisible = false;
      }
      return;
    },
    handleBeforeEnterAnimation() {
      if (!this.isEdit) {
        return this.initFormData();
      }
    },
    computedRoleTime(value) {
      if (value.length === 3) {
        value = `0${value}`
      }

      const { hour, min } = extractTimeAndMin(value);
      if (hour === undefined && min === undefined) {
        return "";
      }

      return `${hour}:${addZeroPlaceholders(min)}`;
    },
    handleFromShiftInput(event) {
      this.formData.from = this.computedRoleTime(event.target.value);
    },
    handleToShiftInput(event) {
      this.formData.to = this.computedRoleTime(event.target.value);
    },
    handleRestShiftInput(event) {
      this.formData.rest = this.computedRoleTime(event.target.value);
    },
    // emit handler from Colorbox component
    setSelectedColor(colorStr) {
      return this.formData.color = colorStr;
    },
    // We pass empty string to the request if its a default color
    setColorDataForSubmit() {
      if (this.formData.color === OPLUS_COLOR_PALETTE.DEFAULT) {
        return "none"
      } else {
        return this.formData.color;
      }
    },
    async handleSubmit() {
      if (this.isLoading) {
        return;
      }

      if (!this.formData.name) {
        alertModal.alert("業務名を入力して下さい。");
        return;
      }
      this.isLoading = true;
      const roleDataClone = {...this.formData}
      if (roleDataClone.type === "1") {
        roleDataClone.isDisabledWhenFull = false;
      }
      roleDataClone.from = roleDataClone.from.trim();
      roleDataClone.to = roleDataClone.to.trim();
      roleDataClone.from = roleDataClone.from.length === 3 ? `0${roleDataClone.from}` : roleDataClone.from;
      roleDataClone.to = roleDataClone.to.length === 3 ? `0${roleDataClone.to}` : roleDataClone.to;

      roleDataClone.color = this.setColorDataForSubmit();
      if (this.isEdit) {
        try {
          const response = await putRoleRequest(this.selectedRoleID, roleDataClone);
          updateRoleFromRolesApp(response.role);
        } catch (err) {
          alertModal.alert("Fail to update Role");
          return;
        }
      } else {
        $.post(DashURL("roles"), roleDataClone, (response) => {
          if (response.success) {
            response.role["Alert"] = "空の業務です";
            RolesApp.roles.push(response.role);
            RolesApp.canSubmit = true;

            if (RolesApp.isGroupRoleList) {
              RolesApp.setActiveBranchCountForRole(response.role.ID);
              setNewGroupRoleBranch(response.role.ID);
            }
          }
        });
      }
      this.isVisible = false;
      this.isLoading = false;
      changeRoleCreateBtn(this.isVisible);
      this.initFormData();
    },
    disabledClass(hasPermission) {
      return hasPermission ? "" : "disabled-btn";
    },
    handleDisableDisableWhenFullOption() {
      this.formData.isDisabledWhenFull = false;
    },
    handleSlotTypeClick(slotType) {
      this.formData.slotType = slotType;
    },
    handleRoleTypeClick(roleType) {
      this.formData.type = roleType;
    },
  },
  computed: {
    isEdit() {
      return this.selectedRoleID ? true : false;
    },
    submitButtonText() {
      return this.isEdit ? "編集" : "作成";
    },
    loadingClass() {
      return this.isLoading ? "loading" : "";
    },
    selectedColorBox() {
      return this.formData.color;
    },
    colorBoxStyle() {
      return {
        "backgroundColor": "#" + this.selectedColorBox,
        "borderColor": "#" + this.selectedColorBox
      }
    },
    disableRoleForm() {
      // Disable form from editing if:
      // its an edit
      // is not a group owner
      // role is a group role
      return this.isEdit && !this.isGroupOwner && this.formData.groupWide
    },
    selectedOemText() {
      let text = "";
      switch (this.selectedOem) {
        case 0:
          text = "KOT"
          break;
        case 1:
          text = "勤革時"
          break;
        case 2:
          text = "ToT"
          break;
        case 3:
          text = "セコム"
          break;
        case 4:
          text = "おまかせ"
          break;
        case 5:
          text = "Freee"
          break;
        case 6:
          text = "オフィス"
          break;
        default:
          text = "KOT"
          break;
      }

      return text;
    },
    roleTypeToStr() {
      return this.formData.type === ROLE_VIEW_TYPE.DAY_VIEW ? '曜日別' : 'スタッフごと';
    },
    disableTheDisabledWhenFullOption() {
      return this.formData.type == "1"; //=== doesn't work
    },
    optionDisabledClass() {
      return {
        "disabled": this.formData.type == "1", // dashboard_base.html has this css
      }
    },
    slotTypeToStr() {
      return slotTypeString[this.formData.slotType]
    },
    slotTypes() {
      return Object.entries(slotTypeString);
    }
  },
  components: {
    ColorBox,
    RolesTable,
  },
}
</script>

<template>
  <transition name="slide-fade" @before-enter="handleBeforeEnterAnimation">
    <form v-show="isVisible" @submit.prevent="handleSubmit" @click="(event) => handleRoleContainerClick(event)" :inert="disableRoleForm">
      <div class="role-form-container">
        <RolesTable :roles="[formData]" :is-group-role-form="isGroupRoleForm" :use-for-create-or-edit="true"/>
        <!-- left side -->
        <details class="accordion role-details" open>
          <summary class="accordion-header c-hand">
            <div class="d-flex flex-align-center flex-gap">
              <i class="icon icon-arrow-right mr-1"></i>
              <span class="role-form-title">
                <span>詳細</span>
              </span>
            </div>
          </summary>
          <div class="accordion-body">
            <div class="role-form-title-divider"></div>
            <div class="form-padding relative">
              <label class="oplus-form-text" for="role-name">ラベル (必須)
                <input v-model="formData.name" type="text" name="role-name" id="" placeholder="業務名">
                <div class="color-box-pos">
                  <div ref="color-box" class="role-form-color-wrapper" @click="openColorBox">
                    <div class="role-form-color-box" :style="colorBoxStyle"></div>
                    <span class="role-form-color-text">色塗り
                      <transition name="slide-up">
                        <ColorBox class="oplus-color-box" :selected-color="selectedColorBox" :is-visible="isColorBoxVisible" @color-select="setSelectedColor"/>
                      </transition>
                    </span>
                  </div>
                </div>
              </label>
            </div>
            <div class="form-padding">
              <label class="oplus-form-text" for="role-purpose">
                説明
                <input v-model="formData.purpose" type="text" name="role-purpose" placeholder="朝番, レジ">
              </label>
            </div>
            <div class="form-padding">
              <div class="role-flex-wrapper" data-columns="2">
                <div class="role-flex-child-wrap">
                  <div>
                    <label class="oplus-form-text" for="role-from">
                      から
                      <input :value="formData.from" @change="handleFromShiftInput" type="text" name="role-from" id="" placeholder="10, 10:00, 1000">
                    </label>
                  </div>

                  <div>
                    <label class="oplus-form-text" for="role-to">
                      まで
                      <input :value="formData.to" @change="handleToShiftInput" type="text" name="role-to" id="" placeholder="18, 18:00, 1800">
                    </label>
                  </div>
                </div>

                <div class="role-flex-child-wrap">
                  <div>
                    <label class="oplus-form-text" for="role-rest">
                      休憩時間
                      <input :value="formData.rest" @change="handleRestShiftInput" type="text" name="role-rest" id="" placeholder="1, 1:30">
                    </label>
                  </div>

                  <div>
                    <label class="oplus-form-number" for="role-wage" :class="disabledClass(havePermission.role)">
                      時給
                      <input v-model="formData.wage" type="number" name="role-wage" id="" placeholder="1000" :disabled="!havePermission.role">
                    </label>
                  </div>
                </div>

              </div>
            </div>
            <span class="form-padding role-form-title accordion-header">設定</span>
            <div class="role-form-title-divider sub"></div>

            <div class="form-padding role-flex-wrapper">
              <div class="role-flex-child-wrap flex-column">
                <div class="role-setting-header">
                  <span class="oplus-form-text">割り当て方法</span>
                  <span v-if="!havePermission.auto" class="pro-auto-lock tooltip" data-tooltip="この機能は、&#10;自動作成のアップグレード&#10;が必要となります。">
                    <i class="zmdi zmdi-lock zmdi-hc-lg"></i>
                  </span>
                </div>
                <div class="role-flex-wrapper" data-columns="2" :class="disabledClass(havePermission.auto)">
                  <div class="padding-top dropdown">
                    <div class="shift-dropdown dropdown-toggle" tabindex="0">
                      <span class="shift-dropdown-text">{{ roleTypeToStr }}</span>
                      <svg class="svg-header-dimension-down-arrow">
                        <use xlink:href="/static/dashboard/oplus_custom_icons-1.svg#down-arrow-icon"/>
                      </svg>
                    </div>
                    <div class="shift-dropdown-menu menu">
                      <div class="shift-select-items">
                        <span class="shift-select-dropdown-item" @click="handleRoleTypeClick(0)">曜日別</span>
                        <span class="shift-select-dropdown-item" @click="handleRoleTypeClick(1)">スタッフごと</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="role-flex-child-wrap flex-column">
                <div class="role-setting-header">
                  <span class="oplus-form-text">シフトの種類</span>
                </div>
                <div class="role-flex-wrapper" data-columns="2">
                  <div class="padding-top dropdown">
                    <div class="shift-dropdown dropdown-toggle" tabindex="0">
                      <span class="shift-dropdown-text">{{ slotTypeToStr }}</span>
                      <svg class="svg-header-dimension-down-arrow">
                        <use xlink:href="/static/dashboard/oplus_custom_icons-1.svg#down-arrow-icon"/>
                      </svg>
                    </div>
                    <div class="shift-dropdown-menu menu">
                      <div class="shift-select-items">
                        <span v-for="slotType in slotTypes" class="shift-select-dropdown-item" @click="handleSlotTypeClick(slotType[0])">{{ slotType[1] }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-padding role-flex-wrapper">
              <div class="role-flex-child-wrap flex-column">
                <div class="role-setting-header">
                  <span class="oplus-form-text ">シフト表に表示(業務)</span>
                </div>
                <div class="padding-top role-flex-wrapper" data-columns="2">
                  <div class="flex-column">
                    <label class="oplus-form-checkbox">
                      <input v-model="formData.showCount" type="checkbox" id="role-modal-show-count">
                      カウント
                    </label>
                    <label class="oplus-form-checkbox">
                      <input v-model="formData.isCountFixed" type="checkbox" id="role-modal-fix-count">
                      カウント行を固定 
                    </label>
                    <label class="oplus-form-checkbox">
                      <input v-model="formData.showStaffCount" type="checkbox" id="role-modal-show-staff-count">
                      割当
                    </label>
                    <label class="oplus-form-checkbox">
                      <input v-model="formData.isHiddenInShiftPage" type="checkbox" id="role-modal-hidden-in-shift-page">
                      シフト提出ページに非表示
                    </label>
                  </div>
                </div>
              </div>

              <div class="role-flex-child-wrap flex-column">
                <div class="role-setting-header">
                  <span class="oplus-form-text ">その他</span>
                </div>
                <div class="padding-top role-flex-wrapper" data-columns="2">
                  <div class="flex-column">
                    <label v-if="isGroupRoleForm" class="oplus-form-checkbox">
                      <input v-model="formData.groupWide" type="checkbox" id="role-modal-groupwide" :disabled="isGroupRoleForm">
                      他拠点へ同期
                    </label>

                    <label class="oplus-form-checkbox" :class="optionDisabledClass">
                      <input v-model="formData.isDisabledWhenFull" type="checkbox" id="role-modal-disabled-when-full" :disabled="disableTheDisabledWhenFullOption">
                        必要人数を満たしている場合無効
                    </label>

                    <label class="oplus-form-checkbox">
                      <input v-model="formData.nextDayOff" type="checkbox" id="role-modal-nextdayoff">
                      次の日休み
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="role-flex-wrapper form-padding">
              <div>
                <label class="oplus-form-number" for="role-modal-holiday-type">
                  <div class="flex-start-align-center">
                    <span>{{ selectedOemText }}</span>
                    <span>連携</span>
                    <div v-if="!havePermission.KOT && havePermission.pro" class="circle-question tooltip" data-tooltip="この機能をご利用の場合は、&#10;設定画面にてKOTの連携設定を&#10;行ってください。"></div>
                    <div v-if="!havePermission.pro" class="role-kot-pro pro-label small"></div>
                  </div>
                  <input v-model="formData.kotHolidayType" id="role-modal-holiday-type" type="number" placeholder="休暇区分コード" :disabled="!havePermission.KOT">
                </label>
              </div>
              <div>
                <label class="oplus-form-text" for="role-modal-external-id">
                  <span>連携用ID</span>
                  <input v-model="formData.externalID" type="text" id="role-modal-external-id" placeholder="101">
                </label>
              </div>
            </div>
            <div class="form-padding role-form-footer">
              <button v-if="!disableRoleForm" :class="loadingClass" class="oplus-modal-btn oplus-confirm-btn">{{ submitButtonText }}</button>
              <small v-else class="text-error">オーナーのみ設定を編集できます</small>
            </div>
          </div>
        </details>
      </div>
    </form>
  </transition>
</template>

<style scoped>
.oplus-table-wrapper {
  max-height: 100%;
}

.relative {
  position: relative;
}

.role-form-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  padding-bottom: 20px;
  position: relative;
}

.role-details {
  width: 100%;
  padding: 10px 0;
  border: .05rem solid #dadee4;
  border-radius: 5px;
}

.role-form-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 1.1rem;
}

.role-form-title-divider {
  border-bottom: 1px solid #cfcfcf;
  padding: .2rem 0;
  margin-bottom: 1rem;
  width: 100%;
}

.role-form-title-divider.sub {
  width: calc(100% - 20px);
  margin: 0 auto;
}

.role-flex-wrapper {
  display: flex;
  align-items: start;
  width: 100%;
  gap: 20px;
}

.role-flex-child-wrap {
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
}

.role-flex-wrapper > *,
.role-flex-child-wrap > * {
  width: 100%;
}

.role-flex-child-wrap.flex-column {
  gap: 0;
}

.role-section-form-wrapper {
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;
}

.form-padding {
  padding: 0.5rem 1rem;
  box-sizing: border-box;
}

.role-setting-header {
  border-bottom: 1px solid #cfcfcf;
  padding-bottom: .5rem;
}

.form-padding + .form-padding {
  margin-top: 10px;
}

.role-form-color-wrapper {
  border: 0.05rem solid #cfcfcf;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: .3rem;
  gap: 10px;
  cursor: pointer;
}

.role-form-color-text {
  font-size: .8rem;
  color: #a5a5a5;
  position: relative;
}

.role-form-color-box {
  width: 15px;
  height: 15px;
  border: 1px solid;
  border-radius: 3px;
}

.role-form-footer {
  display: flex;
  justify-content: flex-end;
}

.oplus-color-box {
  z-index: 1;
  position: absolute;
  width: fit-content;
  left: -100%;
  top: 0;
  transform: translate(-100%, 0);
}

.oplus-form-checkbox + .oplus-form-checkbox {
  margin-top: 5px;
}
.padding-top {
  padding-top: .5rem
}

.flex-start-align-center {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  gap: 3px;
}

.pro-auto-lock i {
  color: #52a3d5;
  padding: 0 10px;
  cursor: pointer;
}

.pro-auto-lock.tooltip::after {
  text-align: center;
}

.color-box-pos {
  position: absolute;
  top: 0.5rem;
  right: 1rem;
}

/* shift type select */
.shift-dropdown {
  display: flex;
  border-color: #bbbdbf;
  cursor: pointer;
  width: 100%;
  border: .05rem solid #cfcfcf;
  height: 38px;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
}

.shift-dropdown-text {
  padding: 8px;
}

.shift-dropdown-menu {
  padding: 0;
  width: 100%;
}

.shift-select-items {
  width: 100%;
  padding: 0.4rem;
  box-sizing: border-box;
}

.shift-select-dropdown-item {
  width: 100%;
  height: 38px;
  display: flex;
  justify-content: start;
  align-items: center;
  transition: .2s ease;
  cursor: pointer;
  padding-left: 4px;
}

.shift-select-dropdown-item:hover,
.shift-select-dropdown-item.active {
  background-color: #52a3d5;
  color: #fff;
}

.shift-select-dropdown {
  border-radius: 5px;
  background-color: #fff;
  color: #a5a5a5;
  width: 51px;
  position: absolute;
  right: 0;
  top: 50px;
  box-shadow: 0px 1px 4px 1px #8e8e8e91;
  z-index: 5;
  animation: slide-down .2s ease 1;
}

.shift-select-dropdown-wrapper {
  display: flex;
  border-radius: 5px;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

@media (max-width: 600px) {
  .oplus-color-box {
    left: 50%;
  }
  .role-flex-wrapper {
    flex-wrap: wrap;
  }
}

@media (max-width: 365px) {
  .role-flex-child-wrap {
    flex-wrap: wrap;
  }
}

/* Animations */
/* Form */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

/* Colorbox */
.slide-up-enter-active {
  transition: 0.1s ease-out;
}

.slide-up-leave-active {
  transition: 0.2s ease-in-out;
}

.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
}

/* Spectre style override TODO: move in dash if other page needs the redesign */
.form-radio input:checked+ .form-icon {
  background: #52a3d5;
  border-color: #52a3d5;
}

  /* Adds animation to <details> tag */
  details {
    inline-size: 50ch;

    @media (prefers-reduced-motion: no-preference) {
      interpolate-size: allow-keywords;
    }

    &::details-content {
      opacity: 0;
      block-size: 0;
      overflow-y: clip;
      transition: content-visibility .2s allow-discrete, opacity .2s, block-size .2s;
    }

    &[open]::details-content {
      opacity: 1;
      block-size: auto;
    }
  }
</style>
